var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.note)?_c('div',{staticClass:"comment-box",on:{"click":_vm.showBookNote}},[_c('div',[_vm._v(" "+_vm._s(_vm.note.main_title)+" ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.note.content)}})]):_c('div',{staticStyle:{"font-size":"14px"}},[_vm._v("暂无精彩笔记")])])
}
var staticRenderFns = []

export { render, staticRenderFns }